// src/components/admin/AdminGate.jsx
import React, { useEffect, useState } from "react";

const KEY = "hc_admin_ok_v1";

export default function AdminGate({ children }) {
  const [ok, setOk] = useState(false);
  const [input, setInput] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const cached = sessionStorage.getItem(KEY);
    if (cached === "true") setOk(true);
  }, []);

  const submit = (e) => {
    e.preventDefault();
    const secret = import.meta.env.VITE_ADMIN_SECRET;
    if (!secret) {
      setError("Admin secret not configured on this build.");
      return;
    }
    if (input === secret) {
      sessionStorage.setItem(KEY, "true");
      setOk(true);
    } else {
      setError("Invalid passcode.");
    }
  };

  if (!ok) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6">
        <form
          onSubmit={submit}
          className="w-full max-w-sm space-y-4 bg-white shadow-lg rounded-2xl p-6"
        >
          <h1 className="text-xl font-semibold">Restricted</h1>
          <p className="text-sm text-gray-600">
            Enter the admin passcode to continue.
          </p>
          <input
            type="password"
            className="w-full border rounded-xl px-3 py-2"
            placeholder="Admin passcode"
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
          {error && <div className="text-red-600 text-sm">{error}</div>}
          <button
            type="submit"
            className="w-full rounded-2xl px-4 py-2 bg-black text-white"
          >
            Unlock
          </button>
        </form>
      </div>
    );
  }

  return <>{children}</>;
}
